import React, { memo } from 'react';
import { Calendar, Volume2, Edit2, Image as ImageIcon } from 'lucide-react';
interface MemoryCardProps {
  imageUrl?: string;
  hasAudio?: boolean;
  hasDrawing?: boolean;
  title: string;
  date: string;
  preview?: string;
  onPlay?: () => void;
  onEdit?: () => void;
}
const MemoryCard = ({
  imageUrl,
  hasAudio,
  hasDrawing,
  title,
  date,
  preview,
  onPlay,
  onEdit
}: MemoryCardProps) => {
  return <div className="card overflow-hidden transition-transform hover:scale-[1.02] active:scale-[0.98]" data-id="element-144">
      {imageUrl && <div className="relative h-48 -mx-6 -mt-6 mb-4 overflow-hidden" data-id="element-145">
          <img src={imageUrl} alt={title} className="w-full h-full object-cover" data-id="element-146" />
          {hasDrawing && <div className="absolute top-3 right-3 bg-white/90 dark:bg-slate-800/90 p-2 rounded-lg" data-id="element-147">
              <Edit2 className="w-5 h-5 text-lavender" data-id="element-148" />
            </div>}
        </div>}
      <div className="space-y-3" data-id="element-149">
        <div className="flex items-start justify-between" data-id="element-150">
          <h3 className="text-xl font-medium text-gray-800 dark:text-white flex-1" data-id="element-151">
            {title}
          </h3>
          <div className="flex items-center text-gray-500 dark:text-gray-400 ml-4" data-id="element-152">
            <Calendar className="w-4 h-4 mr-1" data-id="element-153" />
            <span className="text-sm" data-id="element-154">{date}</span>
          </div>
        </div>
        {preview && <p className="text-gray-600 dark:text-gray-300 text-lg leading-relaxed" data-id="element-155">
            {preview}
          </p>}
        <div className="flex flex-wrap gap-2" data-id="element-156">
          {hasAudio && <button onClick={onPlay} className="flex items-center px-4 py-2 bg-lavender/10 dark:bg-lavender/20 
                text-lavender rounded-xl hover:bg-lavender/20 transition-colors" aria-label="Play voice recording" data-id="element-157">
              <Volume2 className="w-5 h-5 mr-2" data-id="element-158" />
              <span data-id="element-159">Listen</span>
            </button>}
          <button onClick={onEdit} className="flex items-center px-4 py-2 bg-gray-100 dark:bg-slate-700 
              text-gray-600 dark:text-gray-300 rounded-xl hover:bg-gray-200 
              dark:hover:bg-slate-600 transition-colors" aria-label="Edit memory" data-id="element-160">
            <Edit2 className="w-5 h-5 mr-2" data-id="element-161" />
            <span data-id="element-162">Edit</span>
          </button>
        </div>
      </div>
    </div>;
};
export default MemoryCard;